const AUTH_SERVER_BASE = (import.meta.env.VITE_AUTH_SERVER_BASE || 'https://auth.uwa.agency').replace(/\/$/, '')

export const OAUTH_TOKEN_ENDPOINT = import.meta.env.VITE_OAUTH_TOKEN_ENDPOINT || `${AUTH_SERVER_BASE}/o/token/`
export const OAUTH_REVOKE_ENDPOINT = import.meta.env.VITE_OAUTH_REVOKE_ENDPOINT || `${AUTH_SERVER_BASE}/o/revoke_token/`
export const OAUTH_USERINFO_ENDPOINT = import.meta.env.VITE_OAUTH_USERINFO_ENDPOINT || `${AUTH_SERVER_BASE}/o/userinfo/`

export const OAUTH_AUTHORIZE_ENDPOINT = import.meta.env.VITE_OAUTH_AUTHORIZE_ENDPOINT || `${AUTH_SERVER_BASE}/o/authorize/`

export const OAUTH_CLIENT_ID = import.meta.env.VITE_OAUTH_CLIENT_ID || '2acysZBBE4dcQvhOaEeA63xHuyqdiSvEoisHMkTP'
export const OAUTH_CLIENT_SECRET = ''
export const OAUTH_SCOPE = import.meta.env.VITE_OAUTH_SCOPE || 'openid profile email'
